// extracted by mini-css-extract-plugin
module.exports = {"inputField":"SpecialCourse_inputField__5hMh_","addressTextContainer":"SpecialCourse_addressTextContainer__Pg7FQ"};